module.exports = __webpack_public_path__ + "img/tv.bbe2cfd.svg";